import { combineReducers } from "redux";
import authReducer from "./authReducer";
import giftcards from "./giftcardsSlice";

export default combineReducers({
    authReducer,
    giftcards: giftcards.reducer,
});
